module.exports = __webpack_public_path__ + "media/images/header-mybenefits-47fa7ea7ab019957e8683a820ea92971.jpg";